var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomaSystem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 119,
    viewBox: "0 0 322 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1304_1471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.367 75.1579H239.737V0H164.525V75.1579H184.895V20.3553H191.946V75.1579H212.316V20.3553H219.367V75.1579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.475 0H82.2637V75.1579H157.475V0ZM137.106 54.8026H102.634V20.3553H137.106V54.8026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.789 0V75.1579H267.159V57.9342H301.631V75.1579H322.001V0H246.789ZM301.631 37.5789H267.159V20.3553H301.631V37.5789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8418 75.1579H75.2117V0H54.8418V27.4013H20.3698V0H0V75.1579H20.3698V47.7566H54.8418V75.1579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89095 99.9688H0V116.12H2.89095V99.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3291 108.07H8.66406V110.959H14.4381V116.111H17.3291V108.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4388 116.109H2.89062V118.998H14.4388V116.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4388 97.0781H2.89062V99.967H14.4388V97.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3304 99.9688H14.4395V103.688H17.3304V99.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4518 97.0781H29.6777V99.967H35.4518V97.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3414 109.514H26.7933V102.852H23.9023V119.003H26.7933V112.403H38.3414V119.003H41.2324V102.852H38.3414V109.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6859 99.9688H26.7949V102.858H29.6859V99.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3421 99.9688H35.4512V102.858H38.3421V99.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1918 102.731H62.2773V105.612H65.1918V118.999H68.0827V97.0781H65.1918V102.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2777 105.613H59.3867V113.231H62.2777V105.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3929 113.23H56.502V116.119H59.3929V113.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6976 102.731V97.0781H47.8066V118.999H50.6976V105.612H53.612V102.731H50.6976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5023 105.613H53.6113V113.231H56.5023V105.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1576 97.0781H77.5781V99.967H89.1576V97.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1576 116.109H77.5781V118.998H89.1576V116.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6562 116.112H77.5785V109.418H86.2749V106.537H77.5785V99.9688H74.6562V116.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34 99.967H116.649V118.999H119.572V99.967H126.913V97.0781H109.34V99.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.148 106.473H135.6V97.0781H132.678V118.999H135.6V109.362H147.148V118.999H150.07V97.0781H147.148V106.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.479 116.112H159.401V109.418H168.089V106.537H159.401V99.9688H156.479V116.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.982 97.0781H159.402V99.967H170.982V97.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.982 116.109H159.402V118.998H170.982V116.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.045 99.9688H191.154V106.475H194.045V99.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.626 97.0781H194.047V99.967H205.626V97.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.626 106.477H194.047V109.365H205.626V106.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.626 116.109H194.047V118.998H205.626V116.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.045 113.23H191.154V116.119H194.045V113.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.547 109.363H205.625V116.12H208.547V109.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.547 99.9688H205.625V102.858H208.547V99.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.885 106.629H223.025V109.51H225.916V106.629H228.776V97.0781H225.885V106.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.112 106.633H217.221V109.522H220.112V106.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.221 97.0781H214.33V106.629H217.221V97.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.026 109.512H220.111V119H223.026V109.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.811 99.9688H234.92V106.475H237.811V99.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.382 97.0781H237.803V99.967H249.382V97.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.382 106.477H237.803V109.365H249.382V106.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.311 99.9688H249.389V102.858H252.311V99.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.311 109.363H249.389V116.12H252.311V109.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.811 113.23H234.92V116.119H237.811V113.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.382 116.109H237.803V118.998H249.382V116.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.094 99.967H265.403V118.999H268.326V99.967H275.667V97.0781H258.094V99.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.935 97.0781H284.355V99.967H295.935V97.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.935 116.109H284.355V118.998H295.935V116.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.434 116.112H284.356V109.418H293.052V106.537H284.356V99.9688H281.434V116.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.194 105.613H313.303V113.231H316.194V105.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.42 105.613H307.529V113.231H310.42V105.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.11 102.731H316.195V105.612H319.11V118.999H322.001V97.0781H319.11V102.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.608 102.731V97.0781H301.725V118.999H304.608V105.612H307.53V102.731H304.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.311 113.23H310.42V116.119H313.311V113.23Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1304_1471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 322,
    height: 119,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomaSystem);
export default __webpack_public_path__ + "static/media/homa-system.b6b66cadd5dd7c544798138df45eb61c.svg";
export { ForwardRef as ReactComponent };